export default __webpack_public_path__ + "static/media/ic_link_24.0d641e52.svg";